<template>
  <div>
    <NuxtPage />
    <UNotifications />
  </div>
</template>
